import { DOCUMENT } from '@angular/common';
import { Injectable, NgZone, inject } from '@angular/core';
import { Observable, Subject, fromEvent, merge } from 'rxjs';
import { map, throttleTime } from 'rxjs/operators';
import { SESSION_CONFIG } from './session.tokens';
import { SessionConfig } from './session.types';

@Injectable({ providedIn: 'root' })
export class ActivityMonitorService {
  private cfg = inject(SESSION_CONFIG);
  private doc = inject(DOCUMENT);
  private zone = inject(NgZone);

  private manual$ = new Subject<number>();

  readonly activity$: Observable<number>;

  constructor() {
    const win = this.doc.defaultView;

    this.activity$ = this.zone.runOutsideAngular(() => {
      const ui$ = merge(
        fromEvent(this.doc, 'mousemove'),
        fromEvent(this.doc, 'mousedown'),
        fromEvent<KeyboardEvent>(this.doc, 'keydown'),
        fromEvent(this.doc, 'wheel'),
        fromEvent(this.doc, 'touchstart'),
        fromEvent(this.doc, 'pointerdown'),
        fromEvent(this.doc, 'scroll'),
        fromEvent(this.doc, 'visibilitychange').pipe(
          map(() => (this.doc.visibilityState === 'visible' ? Date.now() : 0))
        )
      ).pipe(
        throttleTime(this.cfg.activityThrottleMs, undefined, { leading: true, trailing: true }),
        map(() => Date.now())
      );

      return merge(ui$, this.manual$);
    });
  }

  markActivity(): void {
    this.manual$.next(Date.now());
  }
}
